import React from "react";
import { AppBar, Toolbar, Typography, Button, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function Header() {
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.1)", // semi-transparent white
        backdropFilter: "blur(10px)", // apply blur effect
        borderRadius: "10px", // rounded corners
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // subtle shadow
        color: "#000000", // changed this to black
        margin: "0 auto", // remove margin to span full width
        width: "100%", // set width to 100% to span the full width
        maxWidth: "none", // remove max width restriction
      }}
    >
      <Toolbar style={{ justifyContent: "space-between", padding: "0 30px" }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "'Dancing Script', cursive", // Add this line to apply the font
            fontWeight: 500,
            fontSize: "calc(10px + 2vmin)",
            color: "#000000", // changed this to black
          }}
        >
          Scripter
        </Typography>
        <div style={{ display: "flex", gap: "15px" }}>
          <Button
            component={RouterLink}
            to="/signup"
            sx={{
              color: "black", // changed this to black
              fontSize: "1.2rem",
              padding: "5px 5px",
              border: "1px solid rgba(0, 0, 0, 0.5)", // semi-transparent black border
              borderRadius: "5px", // rounded corners on the buttons
              backdropFilter: "blur(10px)", // apply blur effect on buttons too if needed
            }}
          >
            Signup
          </Button>
          <Button
            component={RouterLink}
            to="/login"
            sx={{
              color: "black", // changed this to black
              fontSize: "1.2rem",
              padding: "5px 20px",
              border: "1px solid rgba(0, 0, 0, 0.5)", // semi-transparent black border
              borderRadius: "5px", // rounded corners on the buttons
              backdropFilter: "blur(10px)", // apply blur effect on buttons too if needed
            }}
          >
            Login
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
